/*
 * Universal Construct — uc-variant-picker enhancement (~1KB)
 * Singura logică custom: actualizează textul "valoare selectată" + summary-ul dropdown
 * și închide panoul dropdown la selecție. Selecția efectivă o face variant-picker.js nativ
 * (radio .opt-btn → eveniment change → update preț/stoc/poză/URL). Fără JS, totul funcționează
 * (radio-uri native + <details> nativ); acest script doar rafinează UX-ul.
 */
(function () {
  'use strict';

  function syncOption(fieldset, value) {
    fieldset.querySelectorAll('.js-uc-vp-selected, .js-uc-vp-summary').forEach(function (el) {
      el.textContent = value;
    });
    var details = fieldset.querySelector('details.uc-vp__dropdown');
    if (details) details.open = false;
  }

  function bind(root) {
    (root || document).querySelectorAll('.uc-vp').forEach(function (vp) {
      if (vp.dataset.ucVpBound) return;
      vp.dataset.ucVpBound = '1';
      vp.addEventListener('change', function (e) {
        var input = e.target;
        if (!input.classList || !input.classList.contains('opt-btn')) return;
        var fieldset = input.closest('.option-selector');
        if (fieldset) syncOption(fieldset, input.value);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }

  // Re-bind pentru conținut injectat (quick-buy / re-randare secțiune)
  document.addEventListener('quickbuy:loaded', function (e) { bind(e.target || document); });
  document.addEventListener('shopify:section:load', function (e) { bind(e.target || document); });

  // Panoul dropdown e overlay (position:absolute) → închide-l la click în afară, ca să nu blocheze ATC/TBI
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.uc-vp__dropdown[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.open = false;
    });
  });
})();
